<template>
  <div class="container">
    <div class="area_list">
      <div class="area_list_label">地理位置：</div>
      <div class="area_list_value">
        <div
          class="area_list_item"
          :class="item.active ? 'active' : ''"
          v-for="(item, index) in areaList"
          :key="index"
          @click="changeArea(index, item.area_id)"
        >
          {{ item.area_name }}
        </div>
      </div>
    </div>
    <div class="type_tabs">
      <span
        :class="{ active: activeType === 'house' }"
        @click="changeType('house')"
      >
        房型
      </span>
      <span
        :class="{ active: activeType === 'building' }"
        @click="changeType('building')"
      >
        楼栋
      </span>
    </div>
    <div class="room_list" v-if="activeType === 'house'">
      <div
        class="room_list_item"
        v-for="(item, index) in houseList"
        :key="index"
        @click="toHouseDetail(item.fx_id || item.house_id)"
      >
        <img v-if="getFileType(item.cover_picture?.path) !== 'video'" v-lazy="item.cover_picture?.path" />
        <video v-else :src="item.cover_picture?.path" muted preload="metadata" />
        <div class="room_f">
          <div class="title">{{ item.fx_name }}</div>
          <div class="info">
            <span>{{ item.acreage_min }}-{{ item.acreage_max }}㎡</span>
            <span>|</span>
            <span>{{ item.rental_type == 1 ? "整租" : "合租" }}</span>
          </div>
          <div class="price">
            <span class="num">{{ item.price_min }}-{{ item.price_max }}</span>
            <span class="unit">元/月</span>
          </div>
          <div class="tag_list">
            <div
              class="tag_list_item"
              v-for="(item2, index2) in item.appliances"
              :key="index2"
            >
              {{ item2.bq_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="room_list building_list" v-else>
      <div
        class="room_list_item building_list_item"
        v-for="(item, index) in buildingList"
        :key="item.buildingKey || index"
        @click="toBuildDetail(item.id)"
      >
        <img v-if="item.coverType !== 'video'" v-lazy="item.cover" />
        <video v-else :src="item.cover" muted preload="metadata" />
        <div class="room_f">
          <div class="title">{{ item.name }}</div>
          <div class="address">{{ item.address }}</div>
          <div class="price">
            <template v-if="item.hasPrice">
              <span class="num">{{ item.price }}</span>
              <span class="unit">元/月</span>
            </template>
            <span v-else class="empty_price">暂无</span>
          </div>
          <div class="tag_list" v-if="item.tags && item.tags.length">
            <div
              class="tag_list_item"
              v-for="(tag, tagIndex) in item.tags"
              :key="tagIndex"
            >
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <mobile-Loading v-if="isLoading" />
  </div>
</template>
<script>
import { getArea, getHouse, getBuildingLists } from "@/api/lookHouse";
export default {
  data() {
    return {
      query: {
        page: 1,
        per_page: 10,
        area_id: null,
      },
      buildingQuery: {
        page: 1,
        per_page: 10,
        area_id: null,
      },
      total: 0,
      buildingTotal: 0,
      areaList: [],
      houseList: [],
      buildingList: [],
      loadedBuildingKeys: [],
      activeType: "house",
      //距离底部的距离
      offBottom: 0,
      isEnd: false,
      buildingLoading: false,
      isLoading: true,
    };
  },
  mounted() {
    this.initData();
    window.addEventListener("scroll", this.handleScroll);
    this.offBottom = this.$store.state.distanceToBottom;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    initData() {
      const area = getArea();
      const house = getHouse(this.query);
      Promise.all([area, house])
        .then((res) => {
          //处理地区
          res[0].data.forEach((item) => {
            item.active = false;
          });
          this.areaList = res[0].data;
          //处理房源
          this.houseList = res[1].data;
          this.total = res[1].total;
          this.query.page = this.query.page + 1;
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },
    async initHouse(isPage = false) {
      if (!this.isEnd) {
        this.isEnd = true;
        const res = await getHouse(this.query);
        if (!isPage) {
          this.houseList = res.data;
        } else {
          this.houseList = [...this.houseList, ...res.data];
        }
        this.total = res.total;
        this.query.page = this.query.page + 1;
        this.isEnd = false;
      }
    },
    changeArea(i, id) {
      this.areaList.forEach((item, index) => {
        if (i == index) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.query.area_id = id;
      this.query.page = 1;
      this.buildingQuery.area_id = id;
      this.resetBuildingList();
      this.isEnd = false;
      if (this.activeType === "house") {
        this.initHouse(false);
      } else {
        this.initBuilding(false);
      }
    },
    changeType(type) {
      if (this.activeType === type) return;
      this.activeType = type;
      if (type === "building" && !this.buildingList.length) {
        this.initBuilding(false);
      }
    },
    toHouseDetail(id) {
      this.$router.push(`/houseDetail?id=${id}`);
      window.localStorage.setItem("routeTitle", "房间详情");
    },
    toBuildDetail(id) {
      this.$router.push(`/buildDetail?id=${id}`);
      window.localStorage.setItem("routeTitle", "楼栋详情");
    },
    resetBuildingList() {
      this.buildingQuery.page = 1;
      this.buildingList = [];
      this.loadedBuildingKeys = [];
      this.buildingTotal = 0;
      this.buildingLoading = false;
    },
    async initBuilding(isPage = false) {
      if (this.buildingLoading) return;
      this.buildingLoading = true;
      try {
        const res = await getBuildingLists(this.buildingQuery);
        const list = this.getResponseList(res).map(this.formatBuildingItem);
        const nextList = list.filter((item) => {
          if (
            !item.buildingKey ||
            this.loadedBuildingKeys.includes(item.buildingKey)
          ) {
            return false;
          }
          this.loadedBuildingKeys.push(item.buildingKey);
          return true;
        });
        this.buildingList = isPage
          ? [...this.buildingList, ...nextList]
          : nextList;
        this.buildingTotal = Number(
          res.total || res.count || (res.data && res.data.total) || 0
        );
        this.buildingQuery.page = this.buildingQuery.page + 1;
      } finally {
        this.buildingLoading = false;
      }
    },
    getResponseList(res) {
      if (Array.isArray(res.data)) return res.data;
      if (res.data && Array.isArray(res.data.data)) return res.data.data;
      if (res.data && Array.isArray(res.data.list)) return res.data.list;
      if (Array.isArray(res.list)) return res.list;
      return [];
    },
    formatBuildingItem(item) {
      const fallbackCover = require("@/assets/image/error.png");
      const files = item.files || [];
      const labels = (item.labels || []).slice(0, 3);
      const hasMinPrice =
        item.min_price !== null &&
        item.min_price !== undefined &&
        item.min_price !== "";
      const hasMaxPrice =
        item.max_price !== null &&
        item.max_price !== undefined &&
        item.max_price !== "";
      const hasPrice = hasMinPrice && hasMaxPrice;
      return {
        id: item.building_id,
        buildingKey: String(item.building_id || item.id || item.building_name),
        name: item.building_name || item.name || "--",
        address: item.address || "",
        tags: labels
          .map((tag) => tag.bq_name || tag.name || tag)
          .filter(Boolean),
        hasPrice,
        price: hasPrice
          ? `${Number(item.min_price).toFixed(0)}-${Number(
              item.max_price
            ).toFixed(0)}`
          : "暂无",
        cover: files.length && files[0].path ? files[0].path : fallbackCover,
        coverType: files.length && files[0].path ? this.getFileType(files[0].path) : 'image',
      };
    },
    getFileType(path) {
      if (!path) return 'image';
      const videoExts = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'flv', 'mkv', 'wmv'];
      const ext = String(path).split('.').pop().toLowerCase();
      return videoExts.includes(ext) ? 'video' : 'image';
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop; // 滚动条距离顶部的位置
      const clientHeight = document.documentElement.clientHeight; // 可视区域的高度
      const scrollHeight = document.documentElement.scrollHeight; // 页面的总高度
      const distanceToBottom = scrollHeight - scrollTop - clientHeight; // 滚动条距离底部的位置
      if (distanceToBottom <= this.offBottom) {
        if (
          this.activeType === "house" &&
          this.total > (this.query.page - 1) * this.query.per_page
        ) {
          this.initHouse(true);
        } else if (
          this.activeType === "building" &&
          this.buildingTotal >
            (this.buildingQuery.page - 1) * this.buildingQuery.per_page
        ) {
          this.initBuilding(true);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  .area_list {
    position: static;
    padding: 30px 30px 20px;
    box-sizing: border-box;
    display: flex;
    column-gap: 14px;
    &_label {
      color: #333333;
      font-size: 28px;
      font-weight: bold;
      min-width: 130px;
      margin-top: 5px;
    }
    &_value {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 16px;
      font-size: 24px;
      .area_list_item {
        padding: 10px 22px;
        box-sizing: border-box;
        border: 1px solid #eeeeee;
        border-radius: 4px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        transition: all 0.3s ease;
      }
      .active {
        color: #ffa71d;
        border: 1px solid #ffa71d;
      }
    }
  }
  .type_tabs {
    display: flex;
    align-items: center;
    column-gap: 34px;
    padding: 0 30px 24px;
    box-sizing: border-box;
    color: #999999;
    font-size: 30px;
    font-weight: bold;
    span {
      position: relative;
      padding-bottom: 16px;
      cursor: pointer;
      &.active {
        color: #ffa71d;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 48px;
          height: 8px;
          border-radius: 8px;
          background: #ffa71d;
          transform: translateX(-50%);
        }
      }
    }
  }
  .room_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px;
    padding: 10px 30px 50px 30px;
    box-sizing: border-box;
    &_item {
      border: 1px solid #eeeeee;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      img,
      video {
        width: 100%;
        height: 240px;
        object-fit: cover;
      }
      .room_f {
        padding: 16px;
        box-sizing: border-box;
        color: #999999;
        font-size: 22px;
        .title {
          color: #333333;
          font-size: 28px;
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .address {
          margin-top: 8px;
          color: #999999;
          font-size: 22px;
          line-height: 30px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .info {
          display: flex;
          column-gap: 20px;
          align-items: center;
          margin: 10px 0;
        }
        .price {
          margin-bottom: 10px;
          .num {
            font-size: 32px;
            color: #ff4d4d;
            font-weight: bold;
          }
          .unit {
            font-size: 24px;
            color: #666666;
          }
          .empty_price {
            color: #999999;
            font-size: 26px;
            font-weight: bold;
          }
        }
        .tag_list {
          display: flex;
          flex-wrap: wrap;
          column-gap: 10px;
          row-gap: 10px;
          &_item {
            background: #f4f4f4;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 6px 8px;
            box-sizing: border-box;
          }
        }
      }
    }
    &.building_list {
      padding-top: 0;
      .building_list_item {
        img,
        video {
          height: 240px;
        }
        .room_f {
          .price {
            margin-top: 6px;
          }
        }
      }
    }
  }
}
</style>
